import DOMPurify from "dompurify";
import * as z from "zod";

export const HtmlSchema = z
    .string()
    .trim()
    .transform((value, ctx) => {
        const doc = new DOMParser().parseFromString(value, "text/html");
        const isValid = Array.from(doc.body.childNodes).some(
            (node) => node.nodeType === 1,
        );

        if (!isValid) {
            ctx.addIssue({
                code: "custom",
                message: "Invalid HTML",
            });

            return z.NEVER;
        }

        return DOMPurify.sanitize(value);
    })
    .readonly()
    .brand<"HtmlSchema">();

export type HtmlSchema = z.output<typeof HtmlSchema>;
